import {Product} from "@k/js/product";
import {getGetParameterString} from "@k/global/axiosFormWrapper";
import axios from "axios";
import {getURLPrefixOfflineVsOnline} from "@k/global/globalUtils";

export function loadSizeTable(product:Product, language:string) {
    return new Promise<string>(resolve=>{
        const parameters = getGetParameterString(
            {
                tab:"sizes",
                landessprache:language,
                sport:product.websportUnterDemDasProduktGehostetIstUebersetzt,
                product:product.productWebInt,
                content:product.productWebInt,
                konfi:1
            }
        )
        axios.get(getURLPrefixOfflineVsOnline() + "/newhp/php/getTabContent.php?" + parameters).then((result)=>resolve(result.data))
    })

}